const Module = () => import('./Module.vue')
const Report = () => import('./views/PersonalityReport.vue')

const reportProps = route => ({
  id: route.params.id,
  candidateId: route.query.candidateId || null,
  pdf: String(route.query.pdf).toLowerCase() === 'true',
  otp: route.query.otp,
  anonymized:
    !route.query.anonymized ||
    String(route.query.anonymized).toLowerCase() === 'true'
})

const shareProps = route => ({
  shareId: route.params.share_id,
  id: null,
  candidateId: route.query.candidateId || null,
  pdf: String(route.query.pdf).toLowerCase() === 'true',
  otp: route.query.otp,
  anonymized:
    !route.query.anonymized ||
    String(route.query.anonymized).toLowerCase() === 'true'
})

const moduleRoute = {
  path: '/personality',
  component: Module,
  meta: {
    requiresAuth: true
  },
  children: [
    {
      name: 'Personality',
      path: ':id',
      component: Report,
      props: reportProps
    },
    {
      name: 'PersonalityShare',
      path: 'share/:share_id',
      component: Report,
      props: shareProps
    }
  ]
}

export default router => {
  router.addRoute(moduleRoute)
}
